import { render, staticRenderFns } from "./after-registration.vue?vue&type=template&id=af4664d6&scoped=true&"
import script from "./after-registration.vue?vue&type=script&lang=ts&"
export * from "./after-registration.vue?vue&type=script&lang=ts&"
import style0 from "./after-registration.vue?vue&type=style&index=0&id=af4664d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4664d6",
  null
  
)

export default component.exports